// Hand-made graph writes: entities and relationships an analyst adds, held to the case schema.
import type { GraphViewNode } from '@/types/graph-view'
import { apiClient } from './client'

/** A form value: Neo4j properties are flat scalars. `null` / `''` = left empty. */
export type ManualPropertyValue = string | number | boolean | null

export interface ManualEntityRequest {
  type: string
  properties: Record<string, ManualPropertyValue>
}

export interface DuplicateCandidate {
  id: string
  name: string
  type_label: string | null
  /** `unique` = shares a unique property's value (what entity resolution merges on). */
  reason: 'unique' | 'name'
  matched_properties: string[]
}

export interface ManualRelationshipRequest {
  source_id: string
  target_id: string
  type: string
}

export interface ManualRelationship {
  id: string
  type: string
  source: string
  target: string
  properties: Record<string, unknown>
}

/** The 422 body of a write the case schema does not allow. */
export interface ManualGraphRefusal {
  code: string
  message: string
  fields: Record<string, string>
}

export const manualGraphApi = {
  createEntity: (caseId: string, body: ManualEntityRequest) =>
    // Answered as the graph views hold their nodes (GraphViewNode).
    apiClient.post<GraphViewNode>(`/v1/cases/${caseId}/graph/entities`, body),

  findDuplicates: (caseId: string, body: ManualEntityRequest) =>
    apiClient.post<{ candidates: DuplicateCandidate[] }>(
      `/v1/cases/${caseId}/graph/entities/duplicates`,
      body
    ),

  createRelationship: (caseId: string, body: ManualRelationshipRequest) =>
    apiClient.post<ManualRelationship>(`/v1/cases/${caseId}/graph/relationships`, body),
}
